(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.announcement').forEach(function (bar) {
      var sectionId = bar.dataset.sectionId;
      var storageKey = 'mjt-announcement-' + sectionId + '-dismissed';
      var dismissible = bar.dataset.dismissible === 'true';

      if (dismissible) {
        try {
          if (window.localStorage && window.localStorage.getItem(storageKey)) {
            bar.setAttribute('data-dismissed', 'true');
            return;
          }
        } catch (e) {}

        var btn = bar.querySelector('[data-announcement-dismiss]');
        if (btn) {
          btn.addEventListener('click', function () {
            bar.setAttribute('data-dismissed', 'true');
            try {
              window.localStorage && window.localStorage.setItem(storageKey, '1');
            } catch (e) {}
          });
        }
      }

      var list = bar.querySelector('.announcement__list');
      if (!list) return;
      var items = list.querySelectorAll('.announcement__item');
      if (items.length < 2) return;

      var rotationVar = getComputedStyle(bar).getPropertyValue('--announcement-rotation').trim();
      var seconds = parseFloat(rotationVar) || 6;
      var index = 0;
      var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (prefersReduced) return;

      setInterval(function () {
        items[index].classList.remove('is-active');
        index = (index + 1) % items.length;
        items[index].classList.add('is-active');
      }, seconds * 1000);
    });

    function setHeights() {
      var ann = document.querySelector('.announcement:not([data-dismissed="true"])');
      var h = ann ? ann.getBoundingClientRect().height : 0;
      document.documentElement.style.setProperty('--announcement-height', h + 'px');
    }
    setHeights();
    window.addEventListener('resize', setHeights);
    document.addEventListener('shopify:section:load', setHeights);
    document.addEventListener('shopify:section:unload', setHeights);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["b2b-inquiry"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      const sections = (root || document).querySelectorAll('.b2b-inquiry');
      sections.forEach(initSection);
    }

    function initSection(section) {
      if (section.__b2bInit) return;
      section.__b2bInit = true;
      const form = section.querySelector('[data-form]');
      if (!form) return;

      const errorEl = section.querySelector('[data-error]');
      const defaultErrorText = errorEl ? errorEl.textContent.trim() : '';
      const loadTime = Date.now();

      form.addEventListener('submit', async function (e) {
        e.preventDefault();
        const klaviyoKey = section.dataset.klaviyoKey;
        const klaviyoListId = section.dataset.klaviyoListId || '';
        const bookingUrl = section.dataset.bookingUrl || '';
        const salesEmail = section.dataset.salesEmail || 'sales@myjournalto.com';

        if (!form.reportValidity()) return;

        const data = Object.fromEntries(new FormData(form));
        const wantsOptin = !!data.newsletter_optin;
        const consent = !!data.consent;

        // Anti-spam checks: honeypot, time-to-fill, link/keyword filter, rate limit
        const timeToFill = Date.now() - loadTime;
        const isSpam = 
          data.website !== '' || 
          timeToFill < 3000 || 
          /(http:\/\/|https:\/\/|<\s*a\s+href|seo services|crypto|marketing services)/i.test(data.project_details || '') ||
          localStorage.getItem('b2b_inquiry_sent') === 'true';

        if (isSpam) {
          // Silently drop but show fake success to fool the bot
          setState(section, 'success');
          const successHeading = section.querySelector('[data-success-headline]');
          if (successHeading) {
            successHeading.focus();
            successHeading.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
          return;
        }

        if (!consent) {
          setState(section, 'error');
          if (errorEl) {
            errorEl.textContent = 'Please confirm consent to send your inquiry.';
            errorEl.hidden = false;
          }
          const consentInput = form.querySelector('[data-consent]');
          if (consentInput) consentInput.focus();
          return;
        }

        if (!klaviyoKey) {
          fallbackToMailto(data, salesEmail, wantsOptin);
          return;
        }

        setState(section, 'submitting');

        try {
          await window.KlaviyoSubmit.track({
            publicKey: klaviyoKey,
            metric: 'B2B Inquiry Submitted',
            properties: {
              first_name: data.first_name,
              last_name: data.last_name,
              email: data.email,
              company: data.company,
              order_type: data.order_type,
              quantity: data.quantity,
              timeline: data.timeline,
              project_details: data.project_details || '',
              newsletter_optin: wantsOptin,
              booking_url: bookingUrl,
              source: 'for-businesses page'
            },
            profile: {
              email: data.email,
              first_name: data.first_name,
              last_name: data.last_name,
              organization: data.company,
              properties: {
                b2b_lead: true,
                b2b_source: 'for-businesses page'
              }
            }
          });

          if (wantsOptin && klaviyoListId) {
            try {
              await window.KlaviyoSubmit.subscribe({
                publicKey: klaviyoKey,
                listId: klaviyoListId,
                email: data.email,
                customSource: 'B2B inquiry form'
              });
            } catch (subscribeErr) {
              console.warn('B2B inquiry: subscription POST failed', subscribeErr);
            }
          }

          localStorage.setItem('b2b_inquiry_sent', 'true');
          setState(section, 'success');
          const successHeading = section.querySelector('[data-success-headline]');
          if (successHeading) {
            successHeading.focus();
            successHeading.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        } catch (err) {
          setState(section, 'error');
          if (errorEl) {
            errorEl.textContent = defaultErrorText;
            errorEl.hidden = false;
          }
        }
      });
    }

    function setState(section, state) {
      section.dataset.state = state;
      const submit = section.querySelector('[data-submit]');
      if (submit) submit.disabled = state === 'submitting';
      const errorEl = section.querySelector('[data-error]');
      if (errorEl && state !== 'error') errorEl.hidden = true;
    }

    function fallbackToMailto(data, salesEmail, wantsOptin) {
      const subject = 'B2B inquiry from ' + (data.company || (data.first_name + ' ' + (data.last_name || '')).trim() || 'website');
      const lines = [
        'Name: ' + (data.first_name || '') + ' ' + (data.last_name || ''),
        'Email: ' + (data.email || ''),
        'Company: ' + (data.company || ''),
        'Order type: ' + (data.order_type || ''),
        'Estimated quantity: ' + (data.quantity || ''),
        'Timeline: ' + (data.timeline || ''),
        'Newsletter opt-in: ' + (wantsOptin ? 'YES — please add to wholesale list' : 'no'),
        '',
        'Project details:',
        data.project_details || '(none)'
      ];
      window.location.href =
        'mailto:' + salesEmail +
        '?subject=' + encodeURIComponent(subject) +
        '&body=' + encodeURIComponent(lines.join('\n'));
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(); });
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  (function () {
    var drawer = document.getElementById('cart-drawer');
    if (!drawer) return;

    var sectionId = drawer.dataset.sectionId;
    var cartUrl = drawer.dataset.cartUrl || '/cart';
    var contentsSelector = '[data-cart-drawer-contents]';
    var footerSelector = '[data-cart-drawer-footer]';

    function open() {
      if (drawer.open) return;
      if (typeof drawer.showModal === 'function') {
        drawer.showModal();
      } else {
        drawer.setAttribute('open', '');
      }
    }

    function close() {
      if (typeof drawer.close === 'function') {
        drawer.close();
      } else {
        drawer.removeAttribute('open');
      }
    }

    document.addEventListener('click', function (e) {
      var trigger = e.target && e.target.closest && e.target.closest('[data-cart-drawer-trigger]');
      if (trigger) {
        e.preventDefault();
        open();
      }
    });

    drawer.addEventListener('click', function (e) {
      if (e.target === drawer) {
        close();
        return;
      }
      var closer = e.target && e.target.closest && e.target.closest('[data-cart-drawer-close]');
      if (closer) {
        close();
      }
    });

    function setLoading(state) {
      drawer.classList.toggle('is-loading', !!state);
    }

    function updateHeaderCount(count) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = count;
      });
      var wrapper = document.querySelector('[data-cart-count-wrapper]');
      if (wrapper) {
        wrapper.toggleAttribute('hidden', count <= 0);
      }
    }

    function refreshDrawer() {
      // Fetch the section fragment from the cart route, not the current page path.
      // Product/collection pages are cacheable; requesting a cart-dependent section
      // against a cacheable path can hand back a stale (pre-mutation) fragment even
      // though the cart mutation itself succeeded. /cart is never cached this way.
      var url = cartUrl + '?sections=' + sectionId + '&t=' + Date.now();
      // No Accept: application/json here. On /cart that header makes Shopify return the
      // cart JSON (token, items, totals) and ignore ?sections=, so data[sectionId] is undefined.
      return fetch(url, { cache: 'no-store' })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var html = data && data[sectionId];
          if (!html) return;
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var nextContents = doc.querySelector(contentsSelector);
          var liveContents = drawer.querySelector(contentsSelector);
          if (nextContents && liveContents) {
            liveContents.replaceWith(nextContents);
          }
          var nextFooter = doc.querySelector(footerSelector);
          var liveFooter = drawer.querySelector(footerSelector);
          if (nextFooter && liveFooter) {
            liveFooter.replaceWith(nextFooter);
          } else if (nextFooter && !liveFooter) {
            drawer.querySelector('.cart-drawer__panel').appendChild(nextFooter);
          } else if (!nextFooter && liveFooter) {
            liveFooter.remove();
          }
        });
    }

    function fetchCart() {
      return fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); });
    }

    function changeLine(key, quantity) {
      setLoading(true);
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          updateHeaderCount(cart.item_count);
          return refreshDrawer();
        })
        .catch(function () {})
        .finally(function () { setLoading(false); });
    }

    drawer.addEventListener('click', function (e) {
      var inc = e.target && e.target.closest && e.target.closest('[data-cart-line-increase]');
      var dec = e.target && e.target.closest && e.target.closest('[data-cart-line-decrease]');
      var rem = e.target && e.target.closest && e.target.closest('[data-cart-line-remove]');
      if (inc) {
        e.preventDefault();
        var key = inc.dataset.lineKey;
        var line = drawer.querySelector('[data-line-key="' + key + '"]');
        var current = parseInt(line && line.querySelector('.cart-drawer-line__qty-value').textContent, 10) || 1;
        changeLine(key, current + 1);
      } else if (dec) {
        e.preventDefault();
        var dkey = dec.dataset.lineKey;
        var dline = drawer.querySelector('[data-line-key="' + dkey + '"]');
        var dcurrent = parseInt(dline && dline.querySelector('.cart-drawer-line__qty-value').textContent, 10) || 1;
        changeLine(dkey, Math.max(0, dcurrent - 1));
      } else if (rem) {
        e.preventDefault();
        changeLine(rem.dataset.lineKey, 0);
      }
    });

    var noteTimer;
    drawer.addEventListener('input', function (e) {
      var note = e.target && e.target.matches && e.target.matches('[data-cart-drawer-note]') ? e.target : null;
      if (!note) return;
      clearTimeout(noteTimer);
      noteTimer = setTimeout(function () {
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ note: note.value })
        }).catch(function () {});
      }, 600);
    });

    function addToCart(formData) {
      setLoading(true);
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: formData
      })
        .then(function (r) { return r.json(); })
        .then(function () { return fetchCart(); })
        .then(function (cart) {
          updateHeaderCount(cart.item_count);
          return refreshDrawer();
        })
        .then(function () { open(); })
        .catch(function () {})
        .finally(function () { setLoading(false); });
    }

    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || !form.matches) return;
      var action = form.getAttribute('action') || '';
      var isCartAdd = action.indexOf('/cart/add') !== -1;
      var isAtcMarked = form.matches('[data-cart-drawer-add]');
      if (!isCartAdd && !isAtcMarked) return;
      e.preventDefault();
      addToCart(new FormData(form));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  (function () {
    var form = document.querySelector('[data-cart-page-form]');
    if (!form) return;

    form.addEventListener('click', function (e) {
      var inc = e.target && e.target.closest && e.target.closest('[data-qty-increase]');
      var dec = e.target && e.target.closest && e.target.closest('[data-qty-decrease]');
      if (!inc && !dec) return;
      e.preventDefault();

      var wrapper = (inc || dec).closest('.cart-page-line__qty');
      var input = wrapper && wrapper.querySelector('[data-qty-input]');
      if (!input) return;

      var value = parseInt(input.value, 10);
      if (isNaN(value)) value = 0;
      value = inc ? value + 1 : Math.max(0, value - 1);
      input.value = value;

      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit();
      } else {
        form.submit();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      const sections = (root || document).querySelectorAll('.contact-form');
      sections.forEach(initSection);
    }

    function initSection(section) {
      if (section.__contactInit) return;
      section.__contactInit = true;
      const form = section.querySelector('form');
      if (!form) return;

      const loadTime = Date.now();

      form.addEventListener('submit', function (e) {
        const data = Object.fromEntries(new FormData(form));
        const bodyContent = data['contact[body]'] || '';
        const websiteContent = data['contact[website]'] || '';
        
        const timeToFill = Date.now() - loadTime;
        const isSpam = 
          websiteContent !== '' || 
          timeToFill < 3000 || 
          /(http:\/\/|https:\/\/|<\s*a\s+href|seo services|crypto|marketing services)/i.test(bodyContent) ||
          localStorage.getItem('contact_form_sent') === 'true';

        if (isSpam) {
          e.preventDefault(); // Stop actual submission to Shopify
          
          // Render a fake success state
          const card = section.querySelector('.contact-form__card');
          if (card) {
            const headline = section.querySelector('.contact-form__headline')?.textContent || 'Got it. Talk soon.';
            const body = "We'll write back within one working day.";
            
            card.innerHTML = `
              <div class="contact-form__success" aria-live="polite">
                <h3 class="contact-form__success-headline" tabindex="-1">${headline.trim()}</h3>
                <p class="contact-form__success-body">${body}</p>
              </div>
            `;
            const newHeadline = card.querySelector('.contact-form__success-headline');
            if (newHeadline) {
              newHeadline.focus();
              newHeadline.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
          }
          return;
        }

        // Only set localStorage if we are actually letting it submit
        localStorage.setItem('contact_form_sent', 'true');
        
        const submitBtn = section.querySelector('[data-submit]');
        if (submitBtn) submitBtn.disabled = true;
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(); });
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  (function () {
    function bind(form) {
      if (form.dataset.bound) return;
      form.dataset.bound = '1';

      var listId = form.dataset.listId;
      var publicKey = form.dataset.publicKey;
      var signupSource = form.dataset.signupSource || 'footer';
      var input = form.querySelector('input[type="email"]');
      var consent = form.querySelector('[data-consent]');
      var submit = form.querySelector('button[type="submit"]');
      var success = form.querySelector('.site-footer__form-success');
      var errors = form.querySelector('.site-footer__form-error');

      form.addEventListener('submit', function (event) {
        event.preventDefault();
        if (errors) errors.textContent = '';

        if (!publicKey) {
          if (errors) errors.textContent = 'Submissions are not yet wired up. Please come back soon.';
          return;
        }

        var email = (input.value || '').trim();
        if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
          if (errors) errors.textContent = 'Please enter a valid email address.';
          input.focus();
          return;
        }

        if (consent && !consent.checked) {
          if (errors) errors.textContent = 'Please confirm consent to subscribe.';
          consent.focus();
          return;
        }

        submit.disabled = true;

        window.KlaviyoSubmit.subscribe({
          publicKey: publicKey,
          listId: listId,
          email: email,
          signupSource: signupSource,
          customSource: signupSource
        }).then(function () {
          form.querySelector('.site-footer__pill').hidden = true;
          if (consent) consent.closest('.site-footer__consent').hidden = true;
          if (success) success.hidden = false;
        }).catch(function (err) {
          if (errors) errors.textContent = (err && err.message) || 'Something went wrong. Please try again.';
          submit.disabled = false;
        });
      });
    }

    function init() {
      document.querySelectorAll('.site-footer__form[data-klaviyo-form]').forEach(bind);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    document.querySelectorAll('.site-header').forEach(function (header) {
      var dialog = header.querySelector('[data-mobile-menu]');
      var openBtn = header.querySelector('[data-menu-open]');
      var closeBtn = header.querySelector('[data-menu-close]');

      if (openBtn && dialog) {
        openBtn.addEventListener('click', function () {
          if (typeof dialog.showModal === 'function') {
            dialog.showModal();
          } else {
            dialog.setAttribute('open', '');
          }
        });
      }
      if (closeBtn && dialog) {
        closeBtn.addEventListener('click', function () {
          dialog.close();
        });
      }
      if (dialog) {
        dialog.addEventListener('click', function (e) {
          if (e.target === dialog) dialog.close();
        });
        dialog.querySelectorAll('a').forEach(function (a) {
          a.addEventListener('click', function () {
            dialog.close();
          });
        });
      }

      var killSwitchOn = header.dataset.transparentOverFirst === 'true';
      var firstSection = document.querySelector('main > .shopify-section');
      var firstWantsTransparent = !!firstSection
        && !!firstSection.querySelector('[data-header-transparent="true"]');

      if (!killSwitchOn || !firstWantsTransparent) {
        return;
      }

      var sentinel = document.createElement('span');
      sentinel.style.position = 'absolute';
      sentinel.style.bottom = '0';
      sentinel.style.height = '1px';
      sentinel.style.width = '1px';
      sentinel.style.pointerEvents = 'none';
      sentinel.setAttribute('aria-hidden', 'true');
      firstSection.style.position = firstSection.style.position || 'relative';
      firstSection.appendChild(sentinel);

      if (!('IntersectionObserver' in window)) {
        header.classList.add('is-solid');
        return;
      }

      var io = null;
      function topInset() {
        var headerH = header.getBoundingClientRect().height || 72;
        var annVar = getComputedStyle(document.documentElement).getPropertyValue('--announcement-height').trim();
        var annH = parseFloat(annVar) || 0;
        return headerH + annH;
      }
      function bindObserver() {
        if (io) io.disconnect();
        io = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                header.classList.remove('is-solid');
              } else {
                header.classList.add('is-solid');
              }
            });
          },
          { rootMargin: '-' + topInset() + 'px 0px 0px 0px', threshold: 0 }
        );
        io.observe(sentinel);
      }

      bindObserver();

      var lastInset = topInset();
      function maybeRebind() {
        var current = topInset();
        if (Math.abs(current - lastInset) > 1) {
          lastInset = current;
          bindObserver();
        }
      }
      window.addEventListener('load', maybeRebind);
      window.addEventListener('resize', maybeRebind);
      document.addEventListener('shopify:section:load', maybeRebind);
      document.addEventListener('shopify:section:unload', maybeRebind);

      if ('ResizeObserver' in window) {
        new ResizeObserver(maybeRebind).observe(document.documentElement);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-lead-magnet"]) return;
  try {
    
  (function () {
    function bind(form) {
      if (form.dataset.bound) return;
      form.dataset.bound = '1';

      var listId = form.dataset.listId;
      var publicKey = form.dataset.publicKey;
      var signupSource = form.dataset.signupSource || '';
      var input = form.querySelector('input[type="email"]');
      var consent = form.querySelector('[data-consent]');
      var submit = form.querySelector('button[type="submit"]');
      var submitLabel = form.querySelector('.page-magnet__pill-submit-label');
      var success = form.querySelector('.page-magnet__success');
      var errors = form.querySelector('.page-magnet__errors');

      form.addEventListener('submit', function (event) {
        event.preventDefault();
        errors.textContent = '';

        if (!publicKey) {
          errors.textContent = 'Submissions are not yet wired up. Please come back soon.';
          return;
        }

        if (!listId && !signupSource) {
          errors.textContent = 'Submissions are not yet wired up. Please come back soon.';
          return;
        }

        var email = (input.value || '').trim();
        if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
          errors.textContent = 'Please enter a valid email address.';
          input.focus();
          return;
        }

        if (consent && !consent.checked) {
          errors.textContent = 'Please confirm consent to subscribe.';
          consent.focus();
          return;
        }

        var originalLabel = submitLabel ? submitLabel.textContent : '';
        if (submitLabel) submitLabel.textContent = 'Sending';
        submit.disabled = true;

        window.KlaviyoSubmit.subscribe({
          publicKey: publicKey,
          listId: listId,
          email: email,
          signupSource: signupSource,
          customSource: signupSource || 'lead-magnet'
        }).then(function () {
          form.hidden = true;
          if (success) success.hidden = false;
        }).catch(function (err) {
          errors.textContent = (err && err.message) || 'Something went wrong. Please try again.';
          submit.disabled = false;
          if (submitLabel) submitLabel.textContent = originalLabel;
        });
      });
    }

    function init() {
      document.querySelectorAll('form[data-klaviyo-form]').forEach(bind);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["password"]) return;
  try {
    
  (function () {
    function bind(form) {
      if (form.dataset.bound) return;
      form.dataset.bound = '1';

      var listId = form.dataset.listId;
      var publicKey = form.dataset.publicKey;
      var signupSource = form.dataset.signupSource || 'password-page';
      var input = form.querySelector('input[type="email"]');
      var consent = form.querySelector('[data-consent]');
      var submit = form.querySelector('button[type="submit"]');
      var success = form.querySelector('.password-page__form-success');
      var errors = form.querySelector('.password-page__form-error');

      form.addEventListener('submit', function (event) {
        event.preventDefault();
        if (errors) errors.textContent = '';

        if (!publicKey) {
          if (errors) errors.textContent = 'Submissions are not yet wired up. Please come back soon.';
          return;
        }

        var email = (input.value || '').trim();
        if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
          if (errors) errors.textContent = 'Please enter a valid email address.';
          input.focus();
          return;
        }

        if (consent && !consent.checked) {
          if (errors) errors.textContent = 'Please confirm consent to subscribe.';
          consent.focus();
          return;
        }

        submit.disabled = true;

        window.KlaviyoSubmit.subscribe({
          publicKey: publicKey,
          listId: listId,
          email: email,
          signupSource: signupSource,
          customSource: signupSource
        }).then(function () {
          form.querySelector('.password-page__pill').hidden = true;
          var consentLabel = form.querySelector('.password-page__consent');
          if (consentLabel) consentLabel.hidden = true;
          var privacy = form.querySelector('.password-page__privacy');
          if (privacy) privacy.hidden = true;
          if (success) success.hidden = false;
        }).catch(function (err) {
          if (errors) errors.textContent = (err && err.message) || 'Something went wrong. Please try again.';
          submit.disabled = false;
        });
      });
    }

    function init() {
      document.querySelectorAll('.password-page__form[data-klaviyo-form]').forEach(bind);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.product-hero__form').forEach(function (form) {
      var input = form.querySelector('[data-qty-input]');
      var dec = form.querySelector('[data-qty-decrease]');
      var inc = form.querySelector('[data-qty-increase]');
      if (!input || !dec || !inc) return;

      function value() {
        var n = parseInt(input.value, 10);
        return isFinite(n) && n > 0 ? n : 1;
      }
      function set(n) {
        input.value = Math.max(1, n);
      }
      dec.addEventListener('click', function () { set(value() - 1); });
      inc.addEventListener('click', function () { set(value() + 1); });
      input.addEventListener('change', function () { set(value()); });
    });

    document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
      var viewport = gallery.querySelector('[data-viewport]');
      var track = gallery.querySelector('[data-track]');
      var originals = Array.from(gallery.querySelectorAll('[data-slide]'));
      if (!viewport || !track || originals.length <= 1) return;

      var N = originals.length;
      var prevBtn = gallery.querySelector('[data-prev]');
      var nextBtn = gallery.querySelector('[data-next]');
      var dots = Array.from(gallery.querySelectorAll('[data-dot]'));
      var counterCurrent = gallery.querySelector('[data-counter-current]');
      var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function makeClone(slide) {
        var c = slide.cloneNode(true);
        c.setAttribute('data-clone', 'true');
        c.setAttribute('aria-hidden', 'true');
        c.removeAttribute('tabindex');
        c.querySelectorAll('img').forEach(function (img) {
          img.setAttribute('loading', 'lazy');
          img.removeAttribute('fetchpriority');
        });
        return c;
      }

      originals.forEach(function (s) { track.appendChild(makeClone(s)); });
      originals.slice().reverse().forEach(function (s) {
        track.insertBefore(makeClone(s), track.firstChild);
      });

      var domSlides = Array.from(track.children);
      var firstOriginal = N;
      var lastOriginal = N + N - 1;

      if (prevBtn) prevBtn.disabled = false;
      if (nextBtn) nextBtn.disabled = false;

      function slideStep() {
        if (domSlides.length < 2) return viewport.clientWidth;
        var a = domSlides[firstOriginal].getBoundingClientRect();
        var b = domSlides[firstOriginal + 1].getBoundingClientRect();
        return b.left - a.left;
      }

      function physicalIndex() {
        var step = slideStep();
        if (step <= 0) return firstOriginal;
        return Math.round(viewport.scrollLeft / step);
      }

      function logicalIndex(physical) {
        return ((physical - firstOriginal) % N + N) % N;
      }

      function jumpTo(physical) {
        var target = domSlides[physical];
        if (!target) return;
        var prev = viewport.style.scrollBehavior;
        viewport.style.scrollBehavior = 'auto';
        viewport.scrollLeft = target.offsetLeft - viewport.offsetLeft;
        viewport.getBoundingClientRect();
        viewport.style.scrollBehavior = prev;
      }

      function scrollToPhysical(physical, smooth) {
        physical = Math.max(0, Math.min(domSlides.length - 1, physical));
        var target = domSlides[physical];
        if (!target) return;
        viewport.scrollTo({
          left: target.offsetLeft - viewport.offsetLeft,
          behavior: (smooth && !prefersReduced) ? 'smooth' : 'auto'
        });
      }

      function activate(logical) {
        dots.forEach(function (d) {
          var match = parseInt(d.getAttribute('data-target'), 10) === logical;
          d.classList.toggle('is-active', match);
          d.setAttribute('aria-selected', match ? 'true' : 'false');
        });
        if (counterCurrent) counterCurrent.textContent = String(logical + 1);
      }

      function checkLoop() {
        var physical = physicalIndex();
        if (physical < firstOriginal) {
          jumpTo(physical + N);
        } else if (physical > lastOriginal) {
          jumpTo(physical - N);
        }
      }

      if (prevBtn) prevBtn.addEventListener('click', function () {
        scrollToPhysical(physicalIndex() - 1, true);
      });
      if (nextBtn) nextBtn.addEventListener('click', function () {
        scrollToPhysical(physicalIndex() + 1, true);
      });

      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          scrollToPhysical(firstOriginal + parseInt(dot.getAttribute('data-target'), 10), true);
        });
      });

      domSlides.forEach(function (slide) {
        if (!slide.hasAttribute('tabindex')) return;
        slide.addEventListener('keydown', function (event) {
          if (event.key === 'ArrowRight') {
            event.preventDefault();
            scrollToPhysical(physicalIndex() + 1, true);
          } else if (event.key === 'ArrowLeft') {
            event.preventDefault();
            scrollToPhysical(physicalIndex() - 1, true);
          }
        });
      });

      var scrollFrame = null;
      var settleTimer = null;
      viewport.addEventListener('scroll', function () {
        if (scrollFrame) cancelAnimationFrame(scrollFrame);
        scrollFrame = requestAnimationFrame(function () {
          activate(logicalIndex(physicalIndex()));
        });
        if (settleTimer) clearTimeout(settleTimer);
        settleTimer = setTimeout(checkLoop, 180);
      }, { passive: true });

      requestAnimationFrame(function () {
        jumpTo(firstOriginal);
        activate(0);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-purchase"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.product-purchase__form').forEach(function (form) {
      var input = form.querySelector('[data-qty-input]');
      var dec = form.querySelector('[data-qty-decrease]');
      var inc = form.querySelector('[data-qty-increase]');
      if (!input || !dec || !inc) return;

      function value() {
        var n = parseInt(input.value, 10);
        return isFinite(n) && n > 0 ? n : 1;
      }
      function set(n) {
        input.value = Math.max(1, n);
      }
      dec.addEventListener('click', function () { set(value() - 1); });
      inc.addEventListener('click', function () { set(value() + 1); });
      input.addEventListener('change', function () { set(value()); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quiet-evidence"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__mjtEvidenceMounted) return;
    window.__mjtEvidenceMounted = true;

    var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function init() {
      var frames = document.querySelectorAll('[data-evidence-frame]');
      if (!frames.length) return;

      var lightbox = document.querySelector('[data-evidence-lightbox]');
      var lightboxVideo = document.querySelector('[data-evidence-lightbox-video]');
      var lightboxClose = document.querySelector('[data-evidence-lightbox-close]');

      function pauseAllInLightbox() {
        if (!lightboxVideo) return;
        lightboxVideo.pause();
        lightboxVideo.removeAttribute('src');
        lightboxVideo.load();
      }

      function openLightbox(srcUrl, mime) {
        if (!lightbox || !lightboxVideo || !srcUrl) return;
        lightboxVideo.innerHTML = '';
        var source = document.createElement('source');
        source.src = srcUrl;
        if (mime) source.type = mime;
        lightboxVideo.appendChild(source);
        lightboxVideo.muted = false;
        lightboxVideo.load();
        if (typeof lightbox.showModal === 'function') {
          lightbox.showModal();
        } else {
          lightbox.setAttribute('open', '');
        }
        var p = lightboxVideo.play();
        if (p && typeof p.catch === 'function') p.catch(function () {});
      }

      function closeLightbox() {
        pauseAllInLightbox();
        if (lightbox && typeof lightbox.close === 'function') {
          lightbox.close();
        } else if (lightbox) {
          lightbox.removeAttribute('open');
        }
      }

      if (lightboxClose) lightboxClose.addEventListener('click', closeLightbox);
      if (lightbox) {
        lightbox.addEventListener('click', function (e) {
          if (e.target === lightbox) closeLightbox();
        });
        window.addEventListener('scroll', function () {
          if (lightbox.open) closeLightbox();
        }, { passive: true });
      }

      var soundStored = null;
      try { soundStored = window.localStorage.getItem('mjt:evidence:sound'); } catch (e) {}
      var soundOn = soundStored === '1';

      frames.forEach(function (frame) {
        var video = frame.querySelector('[data-evidence-video]');
        var sound = frame.querySelector('[data-evidence-sound]');
        var cc = frame.querySelector('[data-evidence-cc]');

        if (video) {
          video.muted = !soundOn;
        }

        if (sound && video) {
          sound.setAttribute('aria-pressed', soundOn ? 'true' : 'false');
          sound.setAttribute('aria-label', soundOn ? 'Turn sound off' : 'Turn sound on');
          sound.addEventListener('click', function (e) {
            e.stopPropagation();
            soundOn = !soundOn;
            document.querySelectorAll('[data-evidence-video]').forEach(function (v) {
              v.muted = !soundOn;
            });
            document.querySelectorAll('[data-evidence-sound]').forEach(function (s) {
              s.setAttribute('aria-pressed', soundOn ? 'true' : 'false');
              s.setAttribute('aria-label', soundOn ? 'Turn sound off' : 'Turn sound on');
            });
            try { window.localStorage.setItem('mjt:evidence:sound', soundOn ? '1' : '0'); } catch (err) {}
          });
        }

        if (video) {
          video.addEventListener('click', function (e) {
            if (e.target.closest('[data-evidence-sound]') || e.target.closest('[data-evidence-cc]')) return;
            var source = video.querySelector('source');
            if (!source) return;
            openLightbox(source.getAttribute('src'), source.getAttribute('type'));
          });
        }

        if (cc && video) {
          var stored = null;
          try { stored = window.localStorage.getItem('mjt:evidence:cc'); } catch (e) {}
          var enabled = stored === '1';
          var tracks = video.textTracks;
          for (var i = 0; i < tracks.length; i++) {
            tracks[i].mode = enabled ? 'showing' : 'hidden';
          }
          cc.setAttribute('aria-pressed', enabled ? 'true' : 'false');
          cc.addEventListener('click', function (e) {
            e.stopPropagation();
            enabled = !enabled;
            for (var j = 0; j < video.textTracks.length; j++) {
              video.textTracks[j].mode = enabled ? 'showing' : 'hidden';
            }
            cc.setAttribute('aria-pressed', enabled ? 'true' : 'false');
            try { window.localStorage.setItem('mjt:evidence:cc', enabled ? '1' : '0'); } catch (err) {}
          });
        }
      });

      if (prefersReduced || !('IntersectionObserver' in window)) return;

      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var v = entry.target.querySelector('[data-evidence-video]');
          if (!v) return;
          if (entry.intersectionRatio >= 0.5) {
            var p = v.play();
            if (p && typeof p.catch === 'function') p.catch(function () {});
          } else {
            v.pause();
          }
        });
      }, { threshold: [0, 0.5, 1] });

      frames.forEach(function (frame) {
        if (frame.querySelector('[data-evidence-video]')) io.observe(frame);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-testimonials"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__mjtVideoTestimonialsMounted) return;
    window.__mjtVideoTestimonialsMounted = true;

    var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var activeVideo = null;

    function initSection(root) {
      if (root.dataset.vtInit === '1') return;
      root.dataset.vtInit = '1';

      var track = root.querySelector('[data-vt-track]');
      var prev = root.querySelector('[data-vt-prev]');
      var next = root.querySelector('[data-vt-next]');

      if (track && prev && next) {
        var step = function () {
          var card = track.querySelector('.video-testimonials__card');
          if (!card) return track.clientWidth;
          var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
          return card.getBoundingClientRect().width + gap;
        };

        var updateArrows = function () {
          prev.disabled = track.scrollLeft <= 1;
          next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 1;
        };

        prev.addEventListener('click', function () {
          track.scrollBy({ left: -step(), behavior: prefersReduced ? 'auto' : 'smooth' });
        });
        next.addEventListener('click', function () {
          track.scrollBy({ left: step(), behavior: prefersReduced ? 'auto' : 'smooth' });
        });
        track.addEventListener('scroll', updateArrows, { passive: true });
        window.addEventListener('resize', updateArrows);
        updateArrows();
      }

      root.querySelectorAll('[data-vt-frame]').forEach(function (frame) {
        var video = frame.querySelector('[data-vt-video]');
        if (!video) return;

        var play = frame.querySelector('[data-vt-play]');
        var controls = frame.querySelector('[data-vt-controls]');
        var pauseBtn = frame.querySelector('[data-vt-pause]');
        var soundBtn = frame.querySelector('[data-vt-sound]');

        function stop(reset) {
          video.pause();
          if (reset) {
            video.currentTime = 0;
            video.load();
          }
          frame.classList.remove('is-playing');
          controls.hidden = true;
          if (activeVideo === video) activeVideo = null;
        }

        function start() {
          if (activeVideo && activeVideo !== video && activeVideo.__vtStop) {
            activeVideo.__vtStop(true);
          }
          video.muted = false;
          soundBtn.setAttribute('aria-pressed', 'true');
          soundBtn.setAttribute('aria-label', soundBtn.dataset.labelOff);
          var p = video.play();
          if (p && typeof p.catch === 'function') p.catch(function () {});
          activeVideo = video;
          video.__vtStop = stop;
          frame.classList.add('is-playing');
          controls.hidden = false;
          pauseBtn.focus();
        }

        play.addEventListener('click', start);

        pauseBtn.addEventListener('click', function () {
          stop(false);
          play.focus();
        });

        soundBtn.addEventListener('click', function () {
          video.muted = !video.muted;
          soundBtn.setAttribute('aria-pressed', video.muted ? 'false' : 'true');
          soundBtn.setAttribute('aria-label', video.muted ? soundBtn.dataset.labelOn : soundBtn.dataset.labelOff);
        });

        video.addEventListener('ended', function () {
          stop(true);
        });
      });

      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            var v = entry.target.querySelector('[data-vt-video]');
            if (v && !v.paused && entry.intersectionRatio < 0.35 && v.__vtStop) {
              v.__vtStop(false);
            }
          });
        }, { threshold: [0, 0.35] });

        root.querySelectorAll('[data-vt-frame]').forEach(function (frame) {
          if (frame.querySelector('[data-vt-video]')) io.observe(frame);
        });
      }
    }

    function initAll() {
      document.querySelectorAll('[data-video-testimonials]').forEach(initSection);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll, { once: true });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (e) {
      var root = e.target.querySelector('[data-video-testimonials]');
      if (root) initSection(root);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
